// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__overlay___NvopP {
  position: fixed;
  z-index: 50000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
}

  .styles__overlay___NvopP .styles__content___onsWF {
    background: #FFF;
    max-width: 600px;
    padding: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    box-shadow: 0 0 20px rgba(0,0, 0, 0.2);
    color: #BB0000;
    text-align: center;
  }`, "",{"version":3,"sources":["webpack://./ui/error-overlay/styles.pcss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;AAehC;;EAbE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,sCAAsC;IACtC,cAAc;IACd,kBAAkB;EACpB","sourcesContent":[".overlay {\n  position: fixed;\n  z-index: 50000;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n\n  .content {\n    background: #FFF;\n    max-width: 600px;\n    padding: 40px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 5px;\n    box-shadow: 0 0 20px rgba(0,0, 0, 0.2);\n    color: #BB0000;\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `styles__overlay___NvopP`,
	"content": `styles__content___onsWF`
};
export default ___CSS_LOADER_EXPORT___;
